import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { PermissionHelper } from '../shared/permissions/permissions';
import { Configuration } from '../shared/services/configuration';
import { HttpClientCustom } from '../shared/services/http.client';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'tenant-management',
  templateUrl: './tenantManagement.html'
})
export class TenantManagementComponent implements OnInit {
  public _baseUrl: any;
  public tenantData: any = [];
  public pageSize: any = 10;
  public page = 1;
  public startingPage: any = 1;
  public endingPage: any = 10;
  public collectionSize: any;
  public trackHides: any;

  constructor(
    public router: Router,
    public _per: PermissionHelper,
    public _global: Configuration,
    public translate:TranslateService,
    public http: HttpClientCustom
  ) { this._baseUrl = _global.get('EPMS_BASE_URL'); }

  public ngOnInit() {
    this.getAllTenantData();
  }

  public newTenant() {
    this.router.navigate(['./menu/createTenant']);
  }

  public editTenant(tenantId) {
    
    localStorage.setItem('tenantId', tenantId);
    this.router.navigate(['./menu/updateTenant']);
  }

  public tableActions(i) {
    this.trackHides = i;
  }

  public getAllTenantData() {
    let that = this;
    let url = that._baseUrl + 'v1/superAdmin/tenant/search';
    that.http.post(url, { page: that.page, pageSize: that.pageSize })
      .subscribe((result) => {
        that.tenantData = result.content;
        that.collectionSize = result.totalElements;
        if (result.last) {
          that.endingPage = that.collectionSize;
        }
      }, (error) => {
        console.log('Not able to load tenant data');
      });
  }

  // pagination functions
  public onPageChange(event: number): void {
    let that = this;
    if (event === 1) {
      that.startingPage = 1;
      that.endingPage = 10;
    } else {
      that.startingPage = 1 + that.pageSize;
      if (that.collectionSize > that.endingPage) {
        that.endingPage = event + that.endingPage;
      } else {
        that.endingPage = that.collectionSize;
      }
    }
    that.page = event;
    that.getAllTenantData();
  }
  
  public OnPageSizeChanged(val) {
    this.pageSize = val;
    this.getAllTenantData();
  }
}



// WEBPACK FOOTER //
// ./src/app/superAdmin/tenantManagement.ts